import Slider from "../Slider";

interface DurationInputProps {
  label: string;
  value: number;
  onChange: (newValue: number) => void;
  minHours: number;
  maxHours: number;
  rightCorner?: React.ReactElement;
}

const renderHoursMinutes = (hours: number) => {
  const wholeHours = Math.floor(hours);
  const wholeMinutes = Math.round((hours % 1) * 60);
  
  const hoursNotation = !!wholeHours && (wholeHours + (wholeHours > 1 ? " hours" : " hour"));
  const minutesNotation = !!wholeMinutes && (wholeMinutes + (wholeMinutes > 1 ? " minutes" : " minute"));

  return [hoursNotation,minutesNotation].filter(Boolean).join(" ") || "0 hours";
}

const DurationInput: React.FC<DurationInputProps> = ({
  label, value, onChange, minHours, maxHours, rightCorner
}) => {
  return (
    <Slider
      question={label}
      range={value}
      setRange={v => { onChange(v) }} 
      min={minHours} 
      max={maxHours}
      step={0.25}
      rightCorner={rightCorner}
      renderValue={renderHoursMinutes}
    />
  );
}

export default DurationInput;
